 <!--
 * @Author: amywulan
 * @Date: 2020-09-15 18:37:24
 * @LastEditors: amywulan
 * @LastEditTime: 2022-06-16 18:54:18
 * @Description: 新手优惠券
-->
<template>
  <div>
    <div class="new-coupon-center" :style="{background:bannerData.backgroundColor}" v-if="isInit">
      <!-- banner -->
      <img :src="bannerData.skinUrl" class="coupon-banner"/>
      <div class="coupon-content">
        <!-- 我的优惠券 -->
        <my-coupons v-if="isInit" :bannerData="bannerData" @couponsShow="couponsShow" ref="myCoupons"></my-coupons>
        <!-- 获取优惠券 -->
        <get-coupons v-if="isInit" @couponsShow="couponsShow" @getResultInfo="getResultInfo"></get-coupons>
      </div>
    </div>
    <!-- loading -->
    <loading-mask v-show="loading"></loading-mask>
  </div>
</template>

<script>
import * as api from '@/api/newCouponsCenter/index'
import { BANNER_MAP, navConfig, confConfigPercent0, confConfigPercent1, confConfigalpha1 } from './common/enums'
import LoadingMask from '@/components/loading/loading-mask'
import MyCoupons from './components/myCoupons/index'
import GetCoupons from './components/getCoupons/index'
import { get } from 'lodash-es'
import { couponCenterSw } from './track'
import { mapActions } from 'vuex'
import { setTitle } from '@/common/js/bridge'
import loginMixin from '@/common/mixin/login'

export default {
  name: 'newCouponsCenter',
  mixins: [loginMixin],
  components: {
    LoadingMask,
    MyCoupons,
    GetCoupons
  },
  data () {
    return {
      isCouponsShow: false, // 兑换弹窗券包是否展示
      // banner信息
      bannerData: {},
      // loading
      loading: true,
      isInit: false,
      navConfig: {},
      alpha: 0 // 导航栏透明度是否达到。 1是完全不透明。 0是透明
    }
  },
  computed: {
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    },
    // 是否支持沉浸式
    isSupportHurdle () {
      return this.$store.state.isSupportHurdle
    },
    pageTitle () {
      return this.gettext('优惠券中心')
    }
  },
  async created () {
    setTitle(this.gettext('优惠券中心'))
    await this.versionControl()
    this.navConfig = navConfig(this.pageTitle)
    // 设置标题栏及状态栏初始样式
    this.isSupportHurdle && this.updateNav(this.navConfig)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('UPDATE_NEWCOUPONSCENTERFROM', to && to.name)
    next()
  },
  async mounted () {
    // 检测登录
    this.getTokenToLogin(this.getBanner)
    // 监听落地页页面滚动事件
    document.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
    this.updateNavConfig(confConfigalpha1(''))
    this.updateNav(this.navConfig)
    document.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    ...mapActions({
      versionControl: 'versionControl'
    }),
    // 券包pay后优惠券刷新
    getResultInfo () {
      this.$refs.myCoupons.getResultInfo()
    },
    // 滚动监听的方法
    handleScroll () {
      if (this.isCouponsShow) return
      const absY = Math.abs(document.documentElement.scrollTop || document.body.scrollTop)
      // 临界值,上滑到90的时候 titlebar要透明度100%的展现出来
      const criticalY = 104
      const percent = absY / criticalY
      this.isSupportHurdle && this.setNavStyle(percent)
    },
    // 获取banner和背景色信息
    async getBanner () {
      this.isInit = false
      const bannerDefault = BANNER_MAP[this.getCountry]
      try {
        const res = await api.getBanner({country: this.getCountry})
        if (+get(res, 'data.errno') === 0) {
          const data = get(res, 'data.data', {})
          this.bannerData = data || bannerDefault
        } else {
          this.bannerData = bannerDefault
        }
      } catch (error) {
        this.bannerData = bannerDefault
        console.log(error)
      }
      this.isInit = true
      this.loading = false
      // 页面曝光埋点
      couponCenterSw()
    },
    /*
    * 页面滑动时更新标题栏和状态栏的配置。
    * 目前是固定标题和返回按钮的颜色来控制它的透明度。
    * 状态栏sysStatusBar只有在页面初始和返回顶部时的颜色为白色。滑动时一直是黑色。所以这里默认是黑色0
    * shareBtn分享按钮的透明度为1
    */
    updateNavConfig (confConfig = {}) {
      this.navConfig = Object.assign({}, this.navConfig, confConfig)
    },
    updateNav (params) {
      this.SodaBridge('updateNav', params)
    },
    // 设置titlebar样式
    setNavStyle (percent) {
      let confConfig = {}
      if (percent <= 0) {
        confConfig = confConfigPercent0(this.pageTitle)
      } else if (percent <= 1) {
        confConfig = confConfigPercent1(percent, this.pageTitle)
        if (percent < 0.5) {
          confConfig.backBtn.color = '#FFFFFF'
          confConfig.backBtn.alpha = 1 - percent
        } else {
          confConfig.backBtn.color = '#000000'
        }
      } else {
        // 兼容用户滑动速度过快以至于所计算的percent还未到达1时滑动距离已经超过临界值导致状态栏透明度固定在小于1的值不动了。
        // 所以在此做个判断。如果标题栏透明度已经为1时不作为。没到1时需要将其设置为1.
        if (this.alpha < 1) confConfig = confConfigalpha1(this.pageTitle)
      }
      this.alpha = percent
      this.updateNavConfig(confConfig)
      this.updateNav(this.navConfig)
    },
    couponsShow (val) {
      this.isCouponsShow = val
      if (!val) this.handleScroll()
    }
  }
}
</script>

<style scoped lang="scss">
.new-coupon-center{
  min-height: 100vh;
  .coupon-banner{
    width: 100%;
    display: block;
  }
  .coupon-content{
    padding: 0 24px 120px;
  }
}
.mask{
  background: #fff;
}
</style>